import * as giftExchangeRecord from '../services/giftExchangeRecord';

export default {
  namespace: 'giftExchangeRecordFormMolding',

  state: {
    queryOrderDetail: {},
  },

  effects: {
    //详情
    *getQueryOrderDetail({ payload: { values } }, { call, put }) {
      const response = yield call(
        giftExchangeRecord.getQueryOrderDetail,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          queryOrderDetail: response?.data,
        },
      });
    },
    //保存
    *updateOrder({ payload: { values }, callback }, { call }) {
      console.log('values', values);
      const response = yield call(giftExchangeRecord.updateOrder, values);
      callback(response);
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          props.pathname.includes('gift_exchange_record_form_edit') ||
          props.pathname.includes('gift_exchange_record_form_detail')
        ) {
          dispatch({
            type: 'save',
            payload: {
              queryOrderDetail: {},
            },
          });
        }
      });
    },
  },
};
